export const profilePath = '/profile';
export const rootPath = '/';
export const cartPath = '/cart';
export const analyticsPath = '/analytics';
export const seriesPath = '/series';
export const seriesDetailPath = '/series/:seriesId/models/:modelId';
export const orderDashboardPath = '/dashboard';
export const announcementsPath = '/announcements';
export const submissionSuccessPath = '/submission-success';
export const submissionFailurePath = '/submission-failure';
export const userSettingPath = '/user-setting';
export const helpCenterPath = '/help-center';
